module.exports = __webpack_public_path__ + "static/media/sis.fc994cae.png";